<template>
    <div class="w-full shadow mb-1 border rounded-md mx-2 text-sm h-max flex items-center justify-between">
        <div v-if="editWorkflowStep" class="w-full flex flex-col">
            <div class="p-2">
                {{ clientWorkflowStep.workflow_step.step_name }} - {{ clientWorkflowStep.workflow_step.description }}
            </div>
            <div class="w-full h-full p-2">
                <form class="w-full h-full grid grid-cols-4 gap-3" @submit.prevent="editClientWorkflowStep" action="">
                    <div class="flex flex-col">
                        <label class="tracking-widest text-gray-500" for="">Completed On*</label>
                        <input type="date" required class="p-1 border mt-1 border-gray-400 rounded-md" v-model="clientWorkflowStepData.completed_on">
                    </div>
                    <div class="flex flex-col col-span-2">
                        <label class="tracking-widest text-gray-500" for="">Notes</label>
                        <textarea rows="1" class="p-1 border mt-1 border-gray-400 rounded-md" v-model="clientWorkflowStepData.notes"></textarea>
                    </div>
                    <div class="flex flex-col justify-end h-full">
                        <button
                                @click.prevent="showAddFileForm"
                                class="rounded-lg px-2 py-1  flex space-x-1 text-white justify-center items-center bg-dark-primary hover:bg-dark-secondary"
                            >
                            <div class="tracking-normal text-base">
                                Attach Files
                            </div>
                        </button>
                    </div>

                    <div v-if="fileSectionIsLoading" class="col-span-4 flex justify-center items-center w-full h-full">
                        <svg
                            aria-hidden="true"
                            class="w-10 h-10 animate-spin"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="white"
                            />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="#38BDF8"
                            />
                        </svg>
                    </div>
                    <div v-else class="flex justify-center items-center space-y-2 col-span-4">
                        <div class="w-full grid grid-cols-4 max-w-[1000px]">
                            <ExistingDropboxFileThumbnail
                                v-for="file in tempFiles" 
                                :key="getFileId(file)" 
                                :file="file"
                                @remove="removeTempFile"
                            />
                        </div>
                        <!--<label class="tracking-widest text-neutral-6">
                            New File(s)
                        </label>
                        <input
                            @change="processOpportunityFiles"
                            name="opportunityFiles"
                            id="opportunityFiles"
                            type="file"
                            accept=".png, .jpg, .jpeg, .pdf, .pptx, .pptm"
                            class=""
                        />-->
                    </div>
                    <base-modal
                        v-if="visibleAddFileForm"
                        :show-modal-menu-button="false"
                        :is-form-visible="visibleAddFileForm"
                        @close="hideAddFileForm"
                    >
                        <template #header>
                            <div class="text-xl text-primary-extra-dark">
                                Upload File Attachments
                            </div>
                        </template>
                        <template #body>
                            <div v-if="uploadSectionIsLoading" class="bg-neutral-2 rounded-b-xl border-neutral-3 flex justify-center items-center w-full h-full">
                                <svg
                                    aria-hidden="true"
                                    class="w-10 h-10 animate-spin"
                                    viewBox="0 0 100 101"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    >
                                    <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="#38BDF8"
                                    />
                                </svg>
                            </div>
                            <DropboxUploader v-else @upload-file-attachments="uploadFiles"/>
                        </template>
                    </base-modal>
                    <div class="flex col-span-4 justify-center">
                        <base-button-affirmative class="m-2">Save</base-button-affirmative>
                        <base-button-negative @click.prevent="closeEditForm" class="m-2">Cancel</base-button-negative>
                    </div>
                </form>
            </div>
        </div>
        <div v-else-if="clientWorkflowStep.completed_on" class="w-full flex flex-col">
            <div class="flex items-center justify-between">
                <div class="p-2">
                    {{ clientWorkflowStep.workflow_step.step_name }} - {{ clientWorkflowStep.workflow_step.description }}
                </div>
                <div class="flex items-center">
                    <div v-if="canAddOrEdit" @click="openEditForm" class="underline px-2 hover:cursor-pointer text-accent-secondary">
                        Edit
                    </div>
                    <button
                            v-if="isLoading"
                            disabled 
                            class="border mr-2 border-gray-400  bg-gray-400 whitespace-nowrap flex justify-center items-center rounded-md"
                        >
                            <InfiniteSpinnerSVG icon-class="h-4" />
                        </button>
                        <button v-else-if="canAddOrEdit"
                            @click="deleteStep"
                            class="bg-none border mr-2 border-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white bg-dark-secondary whitespace-nowrap flex justify-center items-center rounded-md"
                        >
                        <TrashSVG fill="white" />  
                        </button>
                </div>

            </div>
            <div class="w-full h-full p-2">
                <div class="w-full h-full grid grid-cols-4 gap-3">
                    <div class="flex flex-col">
                        <label class="tracking-widest text-gray-500" for="">Completed On</label>
                        <div>
                            {{ clientWorkflowStepCompletedDate }}
                        </div>
                    </div>
                    <div class="flex flex-col col-span-2">
                        <label class="tracking-widest text-gray-500" for="">Notes</label>
                        <div class="whitespace-pre-line">
                            {{ clientWorkflowStepNotes }}
                        </div>
                    </div>
                    <div class="flex justify-center items-center space-y-2 col-span-4">
                        <div class="w-full grid grid-cols-4 max-w-[1000px]">
                            <ExistingDropboxFileThumbnail
                                v-for="file in clientWorkflowStep.file_attachments" 
                                :key="getFileId(file)" 
                                :file="file"
                                :read-mode="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="w-full flex items-center justify-between">
            <div class="p-2">
                {{ clientWorkflowStep.workflow_step.step_name }}
            </div>
            <div class="flex items-center">
                <div v-if="canAddOrEdit" @click="openEditForm" class="underline px-2 hover:cursor-pointer text-accent-secondary">
                    Start
                </div>
                <button
                            v-if="isLoading"
                            disabled 
                            class="border mr-2 border-gray-400  bg-gray-400 whitespace-nowrap flex justify-center items-center rounded-md"
                        >
                            <InfiniteSpinnerSVG icon-class="h-4" />
                        </button>
                        <button v-else-if="canAddOrEdit"
                            @click="deleteStep"
                            class="bg-none border mr-2 border-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white bg-dark-secondary whitespace-nowrap flex justify-center items-center rounded-md"
                        >
                        <TrashSVG fill="white" />  
                        </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, reactive, computed } from 'vue';
import DropboxUploader from '@/components/base-components/DropboxUploader.vue';
import AttachSVG from '@/components/svg-components/AttachSVG.vue';
import ExistingDropboxFileThumbnail from '@/components/base-components/ExistingDropboxFileThumbnail.vue';
import ChevronDownMiniSVG from '@/components/svg-components/ChevronDownMiniSVG.vue';
import { formatDateTwoDigitYear } from '@/composables/formatDate';
import TrashSVG from '@/components/svg-components/TrashSVG.vue';
import InfiniteSpinnerSVG from '@/components/svg-components/InfiniteSpinnerSVG.vue';
import { useStore } from 'vuex';

const props = defineProps([
    'client', 'clientWorkflowStep', 'canAddOrEdit', 'isLoading'
])
const store = useStore()

const createWorkflowStep = ref(false)
const editWorkflowStep = ref(false)


function openCreateForm(){
    createWorkflowStep.value = true

}

function openEditForm(){
    editWorkflowStep.value = true
}

function closeEditForm(){
    editWorkflowStep.value = false
}

// const clientWorkflowStep = computed(() => {
//     return props.client.workflow_steps.find((step) => {
//         return step.workflow_step.id === props.workflowStep.id
//     })
// })

const clientWorkflowStepCompletedDate = computed(() => {
    return props.clientWorkflowStep ? formatDateTwoDigitYear(props.clientWorkflowStep.completed_on) : null
})

const clientWorkflowStepNotes = computed(() => {
    return props.clientWorkflowStep ? props.clientWorkflowStep.notes : null
})

const emit = defineEmits(['add-workflow-step', 'edit-workflow-step', 'delete-workflow-step'])

function deleteStep(){
    emit('delete-workflow-step', props.clientWorkflowStep.id)
}

const clientWorkflowStepData = reactive({
    notes: props.clientWorkflowStep ? props.clientWorkflowStep.notes : null,
    completed_on: props.clientWorkflowStep ? props.clientWorkflowStep.completed_on : null,
    file_attachments: props.clientWorkflowStep ? props.clientWorkflowStep.file_attachments : []
})

const fileSectionIsLoading = ref(false)
const visibleAddFileForm = ref(false)
const uploadSectionIsLoading = ref(false)

const tempFiles = computed(() => {
    return clientWorkflowStepData.file_attachments
})

function showAddFileForm() {
    visibleAddFileForm.value = true
}

function removeTempFile(id) {
    console.log('remove temp file')
    const tempFileIndex = clientWorkflowStepData.file_attachments.findIndex((file) => {
        return file._id == id
    })
    if(tempFileIndex > -1){
        clientWorkflowStepData.file_attachments.splice(tempFileIndex, 1)
    }
}

function uploadFiles(attachments) {
    console.log('opportunityFile: uploadFiles')
    uploadSectionIsLoading.value = true
    console.log('atachments', attachments)
    attachments.forEach((attachment) => {
        clientWorkflowStepData.file_attachments.push(attachment)
    })
    // emit('upload-files', attachments)
    uploadSectionIsLoading.value = false
    hideAddFileForm()
}

function hideAddFileForm() {
    visibleAddFileForm.value = false
}


function getFileId(file) {
    if(file._id) {
        return file._id
    } else {
        return file.link
    }
}

function completeClientWorkflowStep(){
    console.log('create it', clientWorkflowStepData)
    emit('add-workflow-step', clientWorkflowStepData)
    cancelForm()
}

function editClientWorkflowStep(){
    emit('edit-workflow-step', clientWorkflowStepData, props.clientWorkflowStep.id)
    closeEditForm()
}

function cancelForm(){
    createWorkflowStep.value = false
}



</script>